import TableToolbar from "@rio-cloud/rio-uikit/TableToolbar";
import { useT } from "@hooks";
import ToolbarCreateButton from "../ToolbarCreateButton";
import ToolbarSearch from "../ToolbarSearch";

export type { ColumnDetails, ColumnDetailsMap, ColumnLabel } from "../toolbarTypes";

interface Props {
  searchValue: string;
  handleSearchValueChange: (newSearchValue: string) => void;
  openModal?: (open: boolean) => void;
}

const Toolbar = ({ searchValue, handleSearchValueChange, openModal }: Props) => {
  const t = useT();

  return (
    <TableToolbar>
      <div className="table-toolbar-container">
        <div className="table-toolbar-group-left">
          <ToolbarCreateButton label={t("common.action.add")} onClick={() => openModal?.(true)} />
          <div className="table-toolbar-column  display-flex flex-row gap-10 align-items-center">
            <ToolbarSearch searchValue={searchValue} handleSearchValueChange={handleSearchValueChange} />
          </div>
        </div>
      </div>
    </TableToolbar>
  );
};

export default Toolbar;
